import { fetcher } from '@commenda/utils';
import useSWR from 'swr';

import { BillingInvoiceHelper } from './billing-invoice-helper';
import type { InvoiceRequest, TGetInvoiceResponse } from './types';

export function useInvoice(request: Readonly<InvoiceRequest>) {
  const url = BillingInvoiceHelper.invoiceUrl(request);
  return useSWR<TGetInvoiceResponse>(
    request.companyId && request.invoiceId ? url : null,
    async () => {
      const res = await fetcher(url, { method: 'GET' });
      if (!res.ok) throw new Error('Could not load the invoice.');
      return res.json();
    }
  );
}
